import { render, staticRenderFns } from "./UDIJXSOutlist.vue?vue&type=template&id=0b39aabb&scoped=true"
import script from "./UDIJXSOutlist.vue?vue&type=script&lang=js"
export * from "./UDIJXSOutlist.vue?vue&type=script&lang=js"
import style0 from "./UDIJXSOutlist.vue?vue&type=style&index=0&id=0b39aabb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39aabb",
  null
  
)

export default component.exports